$(document).ready(function() {
  $('.cstm_add-to-cart').click(function(e) {
    e.preventDefault();
    var variantId = $(this).data('variant-id');
    console.log('Variant ID:', variantId);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variantId
      },
      dataType: 'json',
      success: function(response) {
        console.log('Add to cart response:', response);
        
        // updateCartNotification();
        updateCartCount();
        const cartNotification = document.querySelector('cart-notification');
        cartNotification.open();
        
        // Optionally, update mini cart here
      },
      error: function(error) {
        console.log('Error adding to cart:', error);
        // alert('There was an error. Please try again.');
      }
    });
  });

  function updateCartCount() {
    $.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      success: function(cart) {
        if($('.cart-count-bubble span').length == 0) {
          $('#cart-icon-bubble').append(`<div class="cart-count-bubble"><span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span> </div>`);
        } else {
          $('.cart-count-bubble span').text(cart.item_count);
          console.log(cart);
        }
      },
      error: function() {
        console.error('Failed to update cart count');
      }
    });
  }

  function updateCartNotification() {
      $.ajax({
        url: window.location.href, // Current page URL
        method: 'GET',
        success: function (data) {
            var tempDiv = $('<div>').html(data); // Create a temporary jQuery element to hold the response
            var newContent = tempDiv.find('cart-notification'); // Find the content of the specific div
            if (newContent.length) {
                $('cart-notification').html(newContent.html()); // Update the content of the specific div
                const cartNotification = document.querySelector('cart-notification');
                cartNotification.open();
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log('AJAX request failed: ' + textStatus, errorThrown);
        }
    });

  }
  
});
